var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main-contrato-avance-real-view"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('avance-real',{attrs:{"id-contrato":_vm.$route.params.idContrato}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }